import React from "react"
import { Link } from "react-router-dom"

export default function ConversionMissingBanner({ t }) {
  return (
    <div
      className="flex items-center justify-between gap-4 rounded-card border px-5 py-3"
      style={{ background: "#FEF3C7", borderColor: "#FCD34D" }}
    >
      <p className="text-[13px] text-ink-primary" style={{ lineHeight: 1.55 }}>
        {t("dashboard.banners.conversion_missing_headline")}
      </p>
      <Link
        to="/settings"
        className="text-[13px] font-medium text-ai whitespace-nowrap hover:underline"
      >
        {t("dashboard.banners.conversion_missing_cta")}
      </Link>
    </div>
  )
}
